type FieldMap<T> = { [K in keyof Partial<T>]?: string | number };

export function assignToModel<T>(Model: new () => T, raw: any, map?: FieldMap<T>): T {
  const instancia = new Model();
  
  for (const key in instancia) {
    if (Object.prototype.hasOwnProperty.call(instancia, key)) {
      const mappedKey = map?.[key as keyof T] || key;
      if (raw[mappedKey] !== undefined) {
        (instancia as any)[key] = raw[mappedKey];
      }
    }
  }

  return instancia;
}